module.exports = __webpack_public_path__ + "img/20180815_151844_216.4ab80814.jpg";